import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '../api/client';

export const Glossary = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['glossary'],
    queryFn: () => apiFetch<{ content: string }>('/api/glossary'),
  });

  if (isLoading) return <div className="text-sm text-gray-500">読み込み中...</div>;
  if (error !== null) return <div className="text-sm text-red-700">{error.message}</div>;
  if (data === undefined) return null;

  return (
    <div>
      <h2 className="mb-3 text-lg font-semibold">用語集 (readonly)</h2>
      <pre className="rounded border bg-white p-4 text-sm whitespace-pre-wrap">{data.content}</pre>
      <p className="mt-2 text-xs text-gray-500">
        編集は <code>docs/docs/translation/glossary.md</code> へのリポジトリ PR で行ってください。
      </p>
    </div>
  );
};
